interface WeightingValidationSubject {
  id: string;
  weighting: number | null;
}

export const isSelectedWeightingValid = (
  subObjectives: WeightingValidationSubject[],
  keyResults: WeightingValidationSubject[],
  newWeighting: WeightingValidationSubject,
): boolean => {
  if (!newWeighting.weighting) {
    return true;
  }
  const soWeightingSum = Object.values(subObjectives).reduce(
    (prev, current) =>
      !!current.weighting && current.id !== newWeighting.id ? prev + current.weighting : prev,
    0,
  );
  const krWeightingSum = Object.values(keyResults).reduce(
    (prev, current) =>
      !!current.weighting && current.id !== newWeighting.id ? prev + current.weighting : prev,
    0,
  );

  return soWeightingSum + krWeightingSum + newWeighting.weighting <= 100;
};
